import React from "react";
import { Box } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";

interface Props {
  rows: any[];
  columns: GridColDef[];
  loading?: boolean;
  getRowId?: (row: any) => any;
  pageSizeOptions?: number[];
  initialState?: any;
}

const DataTable: React.FC<Props> = ({
  rows,
  columns,
  loading = false,
  getRowId,
  pageSizeOptions,
  initialState,
}) => {
  return (
    <Box className="booking-table-container">
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={getRowId || ((row) => row.id)}
        pageSizeOptions={pageSizeOptions || [10, 20, 50]}
        initialState={
          initialState || {
            pagination: {
              paginationModel: { pageSize: 10, page: 0 },
            },
          }
        }
        disableRowSelectionOnClick
        className="data-grid"
        loading={loading}
        sx={{
          minWidth: 600,

          "& .MuiDataGrid-cell": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },

          "& .MuiDataGrid-columnHeaderTitleContainer": {
            justifyContent: "center",
          },

          "& .MuiDataGrid-columnHeader": {
            display: "flex",
            justifyContent: "center",
          },
        }}
      />
    </Box>
  );
};

export default DataTable;
